module.exports = __webpack_public_path__ + "img/a1-4.65c4365b.png";